import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { useTranslation } from '../context/LanguageContext';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md mx-auto px-4">
        {}
        <div className="mb-8">
          <div className="text-9xl font-bold text-slate-200">404</div>
          <div className="relative -mt-16">
            <Search className="w-24 h-24 text-slate-300 mx-auto" />
          </div>
        </div>

        {}
        <h1 className="text-2xl font-bold text-slate-800 mb-2">
          {t('errors.notFound')}
        </h1>
        <p className="text-slate-500 mb-8">
          {t('errors.notFoundMessage')}
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
          >
            <Home size={18} />
            {t('errors.backToHome')}
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium"
          >
            <ArrowLeft size={18} />
            {t('errors.goBack')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;